import { ApiError } from '@betty/toolkit/api';
import { BottomSheet, resetToRootNavigator } from '@betty/navigation';
import { logError } from '@betty/toolkit/logging';
import Config from '@betty/toolkit/config';

export const processPaymentUrl = (url: string) => {
  if (!url || url.indexOf('payment-result') === -1) {
    return;
  }

  try {
    const { search } = new URL(`${Config.PLATFORM_URL}${url}`);
    const params = new URLSearchParams(search);
    const transactionId =
      params.get('PPP_TransactionID') ||
      params.get('identifier') ||
      params.get('wd_id');

    return transactionId ? { transactionId } : undefined;
  } catch (error) {
    logError('Payment url processing failed', error);
  }
};

export const retrieveTransactionIdFromError = (error: unknown) => {
  if (!(error instanceof ApiError) || !error.data) {
    return;
  }

  if ('transactionId' in error.data) {
    const { transactionId } = error.data;

    return typeof transactionId === 'number' ? transactionId : undefined;
  }
};

export const handleRestrictedFunctionality = (error: unknown) => {
  if (!(error instanceof ApiError)) {
    return;
  }

  const { errorCode } = error.data || {};

  if (errorCode === 'restricted-functionality') {
    resetToRootNavigator(() => {
      BottomSheet.open({
        namespace: 'common',
        type: 'InfoImage',
        data: {
          titleNS: 'common',
          titleKey: 'errorTitle',
          descriptionNS: 'common',
          descriptionKey: 'errorDescription',
        },
      });
    });
  }
};
